import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnalyticalCookiesConsent } from '../../analytical-cookies-consent.enum';

@Component({
  selector: 'feature-cookies-dialog',
  templateUrl: './cookies-dialog.component.html',
  styleUrls: ['./cookies-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookiesDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<CookiesDialogComponent>>(MatDialogRef);
  data = inject<{
    consent: AnalyticalCookiesConsent;
}>(MAT_DIALOG_DATA);

  analyticalCookies: boolean = false;
  necessaryCookies: boolean = true;

  ngOnInit(): void {
    if (this.data.consent === AnalyticalCookiesConsent.REJECTED) {
      this.analyticalCookies = false;
    } else {
      this.analyticalCookies = true;
    }
  }

  confirmButton(): void {
    if (this.analyticalCookies) {
      this.dialogRef.close(AnalyticalCookiesConsent.ACCEPTED);
    } else {
      this.dialogRef.close(AnalyticalCookiesConsent.REJECTED);
    }
  }

  cancelButton(): void {
    this.dialogRef.close(null);
  }
}
